import MESSAGES from "../../../../appMessages";

const COLUMN_CONFIG = {
  SAIA: "SAIA",
  FFE: "FFE",
  DEFAULT: "DEFAULT",
}

const REVERT_COLUMNS = {
  APT_WINDOW: 'shipmentCTA',
  FROZEN_PALLETS: 'freezerPlts',
  NON_FROZEN_PALLETS: 'coolerPlts',
  IBETA: 'shipmentEtaDateTime'
};

const REVERT_COLUMN_CONFIG = {
  [REVERT_COLUMNS.APT_WINDOW]: {
    isModifiedField: 'isAptWindowModified',
    originalValueField: 'originalShipmentCTA',
    revertType: 'revertAPT',
    revertIconTooltipTitle: 'Revert to original APT Window',
    revertField: 'shouldRevertAptWindow',
    noProSelectedErrorMessage: MESSAGES.SHIPMENT_UPDATE.NO_SHIPMENT_SELECTED_APT,
    revertErrorMessage: 'Failed to revert APT window',
    revertSuccessMessage: 'APT window updated',
    confirmDialogProps: {
      title: 'Confirm revert of APT windows',
      contentText: 'APT Window for below Pros will be reverted to original APT Window'
    }
  },
  [REVERT_COLUMNS.FROZEN_PALLETS]: {
    isModifiedField: 'isFreezerPltsModified',
    originalValueField: 'originalFreezerPlts',
    revertType: 'revertFreezerPlts',
    revertIconTooltipTitle: 'Revert to original Frozen Pallets',
    revertField: 'shouldRevertFreezerPlts',
    noProSelectedErrorMessage: MESSAGES.SHIPMENT_UPDATE.NO_SHIPMENT_SELECTED_FROZEN_PALLETS,
    revertErrorMessage: 'Failed to revert Frozen Pallets',
    revertSuccessMessage: 'Frozen pallets updated',
    confirmDialogProps: {
      title: 'Confirm revert of frozen pallets',
      contentText: 'Frozen pallets for below Pros will be reverted to original Frozen Pallets'
    }
  },
  [REVERT_COLUMNS.NON_FROZEN_PALLETS]: {
    isModifiedField: 'isCoolerPltsModified',
    originalValueField: 'originalCoolerPlts',
    revertType: 'revertCoolerPlts',
    revertIconTooltipTitle: 'Revert to original Non Frozen Pallets',
    revertField: 'shouldRevertCoolerPlts',
    noProSelectedErrorMessage: MESSAGES.SHIPMENT_UPDATE.NO_SHIPMENT_SELECTED_NONFROZEN_PALLETS,
    revertErrorMessage: 'Failed to revert Non Frozen Pallets',
    revertSuccessMessage: 'Non Frozen pallets updated',
    confirmDialogProps: {
      title: 'Confirm revert of Non Frozen pallets',
      contentText:
        'Non-frozen pallets for below Pros will be reverted to original Non Frozen pallets'
    }
  },
  [REVERT_COLUMNS.IBETA]: {
    isModifiedField: 'isShipmentEtaDateTimeModified',
    originalValueField: 'originalShipmentEtaDateTime',
    revertType: 'revertIbeta',
    revertIconTooltipTitle: 'Revert to original IB ETA',
    revertField: 'shouldRevertIbeta',
    noProSelectedErrorMessage: MESSAGES.SHIPMENT_UPDATE.NO_SHIPMENT_SELECTED_IBETA,
    revertErrorMessage: 'Failed to revert IB ETA',
    revertSuccessMessage: 'IB ETA updated',
    confirmDialogProps: {
      title: 'Confirm revert of IB ETA',
      contentText: 'IB ETA for below Pros will be reverted to original IB ETA'
    }
  }
};

export { COLUMN_CONFIG, REVERT_COLUMNS, REVERT_COLUMN_CONFIG };